import endpoints, { axios } from "../config/api";

function getTaskTemplates(page: number = 1, search: string) {
  return axios.get(endpoints.taskTemplates.getPage(page));
}

export default getTaskTemplates;
